import Vue from "vue";
import App from "./App.vue";
import router from "./routers";
import store from "@/store";
import ApiService from "@/services/api.service";
import { VERIFY_AUTH } from "@/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import "@/plugins/index.js";
import "@mdi/font/css/materialdesignicons.css";

// Vue Socket IO
import VueSocketIO from 'vue-3-socket.io'
import SocketIO from "socket.io-client";

Vue.use(new VueSocketIO({
    debug: true,
    connection: SocketIO('https://socket.weather.iot.appmedia.id'),
    // options: { path: "/socket" }
}), { secure: false }
)

// API service init
ApiService.init();

const DEFAULT_TITLE = 'Internet of Things | VARX';

router.beforeEach((to, from, next) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
  
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
